import React from "react";
import PropTypes from "prop-types";
import { Modal, ModalBody, FormGroup, Label } from "reactstrap";
import Select from "react-select";
import Swal from "sweetalert2";

const MigrationModal = ({
	isOpen,
	toggle,
	linkedItems,
	organizationalEstructures,
	currentStructureId,
	customStyles,
	onConfirmMigration,
	setMigrationTargetId,
}) => {
	return (
		<Modal isOpen={isOpen} toggle={toggle}>
			<ModalBody>
				<h5>Itens a serem migrados:</h5>
				{linkedItems && (
					<div>
						{linkedItems.goals.length > 0 && (
							<div>
								<h6>Indicadores:</h6>
								<ul>
									{linkedItems.goals.map((goal) => (
										<li key={goal.id}>
											{goal.intention_goals}
										</li>
									))}
								</ul>
							</div>
						)}
						{linkedItems.actions_plans.length > 0 && (
							<div>
								<h6>Planos de Ação:</h6>
								<ul>
									{linkedItems.actions_plans.map((plan) => (
										<li key={plan.id}>{plan.guideline}</li>
									))}
								</ul>
							</div>
						)}
						{linkedItems.ata_referrals.length > 0 && (
							<div>
								<h6>Ata - Encaminhamentos:</h6>
								<ul>
									{linkedItems.ata_referrals.map((ata) => (
										<li key={ata.id}>{ata.referrals}</li>
									))}
								</ul>
							</div>
						)}
						{linkedItems.ata_definitions.length > 0 && (
							<div>
								<h6>Ata - Definições:</h6>
								<ul>
									{linkedItems.ata_definitions.map((ata) => (
										<li key={ata.id}>{ata.definition}</li>
									))}
								</ul>
							</div>
						)}
					</div>
				)}
				<FormGroup className="mb-3">
					<Label htmlFor="migrationTarget">
						Selecionar área para migrar os itens:
					</Label>
					<Select
						styles={customStyles}
						placeholder="Selecione uma Área"
						isClearable={false}
						onChange={(selectedOption) => {
							const selectedValue = selectedOption
								? selectedOption.value
								: null;
							setMigrationTargetId(selectedValue);
						}}
						options={organizationalEstructures.filter(
							(option) => option.value !== currentStructureId,
						)}
					/>
				</FormGroup>
				<div className="hstack gap-2 justify-content-end mb-0">
					<button
						type="button"
						className="btn btn-secondary"
						onClick={toggle}
					>
						Cancelar
					</button>
					<button
						type="button"
						className="btn btn-primary"
						onClick={async () => {
							if (!onConfirmMigration) return;
							onConfirmMigration();
						}}
					>
						Confirmar Migração
					</button>
				</div>
			</ModalBody>
		</Modal>
	);
};

MigrationModal.propTypes = {
	isOpen: PropTypes.bool.isRequired,
	toggle: PropTypes.func.isRequired,
	linkedItems: PropTypes.object,
	organizationalEstructures: PropTypes.array.isRequired,
	currentStructureId: PropTypes.string.isRequired,
	customStyles: PropTypes.object.isRequired,
	onConfirmMigration: PropTypes.func.isRequired,
	setMigrationTargetId: PropTypes.func.isRequired,
};

export default MigrationModal;
